import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AllValues } from '../models/allValues';
import { Coin } from '../models/coin';
import { CoinService } from '../services/coin.service';
import { SystemService } from '../services/system.service';

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.page.html',
  styleUrls: ['./showcase.page.scss'],
})
export class ShowcasePage implements OnInit, OnDestroy {

  form: FormGroup;
  interval: any;
  sm: number;
  coins: Coin[] = [];
  coins2: Coin[] = [];
  allValues: AllValues = new AllValues();

  bond1;
  bond2;


  constructor(private coinService: CoinService, private systemService: SystemService, private fb: FormBuilder) {
    this.form = this.fb.group({
      value: [0.00, Validators.compose([
        Validators.required
      ])],
      result: [],
      coin1: [],
      coin2: [],
    });
  }

  ngOnInit() {
    this.loadValue();
    this.loadValueSm();
    this.loadCoin();
    this.startGetByUpdate();
  }

  loadValue() {
    this.systemService.getAllValue().subscribe(result => {
      this.allValues = result.data;
    });
  }

  loadCoin() {
    this.coinService.getCoin().subscribe(result => {
      this.coins = result.data;
      this.bond1 = this.coins[0].bond;
      this.form.patchValue({
        coin1: this.coins[0].bond
      });
      this.loadCoinOp(this.bond1);
    });
  }

  loadCoinOp(bond) {
    this.coinService.getOp(bond).subscribe(result => {
      this.coins2 = result.data;
      this.bond2 = this.coins2[0].bond;
      this.form.patchValue({
        result: [],
        coin2: this.bond2
      });
    });
  }

  loadValueSm() {
    this.systemService.getValueSm().subscribe(result => {
      this.sm = result.data.toFixed(2);
    });
  }

  async changeCoinInput(event) {
    this.bond1 = event.target.value;

    this.loadCoinOp(this.bond1);

    this.calc(this.form.get('value').value);
  }

  async changeCoinOutput(event) {
    this.bond2 = event.target.value;

    this.calc(this.form.get('value').value);
  }


  calc(event) {
    const value = parseFloat(event);
    if (this.bond1 === 1 && this.bond2 === 1) {
      this.form.patchValue({
        result: value.toFixed(2)
      });
    }

    if (this.bond1 === 1 && this.bond2 === 2) {
      const rs = value * this.allValues.realBs;
      this.form.patchValue({
        result:  rs.toFixed(2)
      });
    }

    if (this.bond1 === 1 && this.bond2 === 3) {
      const rs = value / this.allValues.realDolar;
      this.form.patchValue({
        result: rs.toFixed(2)
      });
    }

    if (this.bond1 === 2 && this.bond2 === 2) {
      this.form.patchValue({
        result: value.toFixed(2)
      });
    }

    if (this.bond1 === 2 && this.bond2 === 1) {
      const rs = value / this.allValues.bsReal;
      this.form.patchValue({
        result: rs.toFixed(2)
      });
    }

    if (this.bond1 === 2 && this.bond2 === 3) {
      const rs = value / this.allValues.bsDolar;
      this.form.patchValue({
        result: rs.toFixed(2)
      });
    }

    if (this.bond1 === 3 && this.bond2 === 3) {
      this.form.patchValue({
        result: value.toFixed(2)
      });
    }

    if (this.bond1 === 3 && this.bond2 === 2) {
      const rs = value * this.allValues.dolarBs;
      this.form.patchValue({
        result: rs.toFixed(2)
      });
    }

    if (this.bond1 === 3 && this.bond2 === 1) {
      const rs = value * this.allValues.dolarReal;
      this.form.patchValue({
        result: rs.toFixed(2)
      });
    }



  }

  async startGetByUpdate() {
    this.interval = setInterval(async () => {
      await this.loadValue();
      await this.loadValueSm();
      await this.loadCoin();
    }, 60000);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
